<template>
  <section class="main-content">
    <MainBanner banner="homepage" />
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite - ito consult GmbH",
        "item": "https://ito-consult.de"
      }]
    }
  </script>
    <section class="block-content py-5">
      <div class="container mb-md-5 py-md-5">
        <div class="content-midwide" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">

          <article v-html="home_content"></article>
        </div>
      </div>
    </section>
    <section class="block-content mb-5">
      <div class="container my-md-5 py-md-5">
        <div class="bg-animation bg-left d-none d-md-block" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="100">
          <svg xmlns="http://www.w3.org/2000/svg" class="animatedSVG" viewBox="0 0 300 300">
            <linearGradient id="svggradient" gradientUnits="userSpaceOnUse" x1="22.9255" y1="150.313" x2="277.0436" y2="150.313">
              <stop  offset="0" style="stop-color:#E30613"/>
              <stop  offset="1" style="stop-color:#000000"/>
            </linearGradient>
            <path class="p1" d="M204.1,23.3H95.9c-40.3,0-73,32.7-73,73v108.1c0,40.3,32.7,73,73,73h108.1c40.3,0,73-32.7,73-73V96.2C277,55.9,244.4,23.3,204.1,23.3z M275.1,202.3c0,40.3-32.7,73-73,73h-104c-40.3,0-73-32.7-73-73v-104c0-40.3,32.7-73,73-73h104c40.3,0,73,32.7,73,73V202.3z"/>
            <path class="p2" d="M278.1,98.7l-76.5-76.5c-28.5-28.5-74.7-28.5-103.2,0L21.9,98.7c-28.5,28.5-28.5,74.7,0,103.2l76.5,76.5c28.5,28.5,74.7,28.5,103.2,0l76.5-76.5C306.6,173.4,306.6,127.2,278.1,98.7z M201.7,275.5c-28.5,28.5-74.7,28.5-103.2,0L24.9,202c-28.5-28.5-28.5-74.7,0-103.2l73.6-73.6c28.5-28.5,74.7-28.5,103.2,0l73.6,73.6c28.5,28.5,28.5,74.7,0,103.2L201.7,275.5z"/>
            <path class="p3" d="M230.7,64.4l-93.6-40.7c-34.9-15.2-75.5,0.8-90.6,35.7L5.7,152.9c-15.2,34.9,0.8,75.5,35.7,90.6l93.6,40.7c34.9,15.2,75.5-0.8,90.6-35.7l40.7-93.6C281.5,120.2,265.6,79.6,230.7,64.4z M224.7,246.1C209.5,281,168.9,297,134,281.8l-90-39.2C9.2,227.4-6.8,186.8,8.4,152l39.2-90c15.2-34.9,55.8-50.8,90.6-35.7l90,39.2c34.9,15.2,50.8,55.8,35.7,90.6L224.7,246.1z"/>
          </svg>
        </div>
        <div class="row my-md-5 py-md-5 align-items-center" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
          <div class="col-12 col-md-5 mb-3 mb-md-0">
            <div class="img-container">
              <img width="640" height="640" class="img-fluid" v-if="home_project_image" :src="generateThumbnail(home_project_image.data.asset_url,640,360,50,'contain')" title="Projekte der ito">
            </div>
          </div>
          <div class="col-12 col-md-6 offset-md-1">

            <article v-html="home_project_content"></article>
            <router-link :to="{name : 'projects' }" class="btn btn-outline-ito hover-red animated-arrow mt-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
              </svg>
              Jetzt Projekte durchsuchen
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <ServicesContent />
    <PartnerContent />

  </section>
</template>

<script>
import store from '@/store'
const MainBanner = () => import('@/components/Content/MainBanner.vue')
const PartnerContent = () => import('@/components/Content/PartnerContent.vue')
const ServicesContent = () => import('@/components/Content/ServicesContent.vue')

export default {
  name: 'Home',
  data: function () {
    return {
      placeholder800: require('@/assets/gfx/placeholder_800x450.jpg')
    }
  },
  computed: {
    home_content () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Homepage-Einleitung') > -1
        })
        return txt.length ? txt[0].content : ''
      } else {
        return ''
      }
    },
    home_project_image () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Homepage-Projekte') > -1
        })
        return txt.length ? txt[0].image : ''
      } else {
        return ''
      }
    },
    home_project_content () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Homepage-Projekte') > -1
        })
        return txt.length ? txt[0].content : ''
      } else {
        return ''
      }
    }
  },
  methods: {
    generateThumbnail (asset, w, h, q, f) {
      return 'https://cdn.ito-consult.de' + asset + '?w=' + w + '&h=' + h + '&q=' + q + '&f=' + f
    }
  },
  components: {
    MainBanner,
    PartnerContent,
    ServicesContent
  },
  mounted () {
    store.commit('loadingStatus', false)
  }
}
</script>
